import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import flattenChildren from '../../helpers/flattenChildren';
import { useRouter } from 'next/router';
import useSeriesOfArticles from '../../contexts/useSeriesOfArticles';
import Link, { getFullyQualifiedArticlePath } from '../Link/Link';
import useGame from '../../../resources/js/contexts/useGame';
import Heading from '../../../resources/js/components/Heading/Heading';
import useGameSlug from '../../hooks/useGameSlug';

export function Title_SeriesOfArticles() {
  return null;
}
export function Description_SeriesOfArticles() {
  return null;
}

function getLinkComparer(links) {
  return JSON.stringify(
    links.map((link) => ({
      href: link.props.href,
      children: link.props.children.filter(
        (x) => typeof x === 'string' || x instanceof String
      ),
    }))
  );
}

function SeriesOfArticles({ children }) {
  const router = useRouter();
  const { setNextLink, setPreviousLink } = useSeriesOfArticles();
  const game = useGame();
  const gameSlug = useGameSlug();

  const [links, setLinks] = useState([]);
  useEffect(() => {
    const newLinks = flattenChildren(children, game).filter(
      (x) => x.type === Link
    );

    if (getLinkComparer(links) !== getLinkComparer(newLinks))
      setLinks(newLinks);
  }, [children, links, game]);

  useEffect(() => {
    const currentLinkIndex = links.findIndex(
      (x) =>
        getFullyQualifiedArticlePath(x.props.href, gameSlug) === router.asPath
    );
    setNextLink(
      currentLinkIndex < links.length - 1 ? links[currentLinkIndex + 1] : null
    );
    setPreviousLink(currentLinkIndex > 0 ? links[currentLinkIndex - 1] : null);

    return () => {
      setNextLink(null);
      setPreviousLink(null);
    };
  }, [gameSlug, links, router.asPath, setNextLink, setPreviousLink]);

  const title = children?.find((x) => x.type === Title_SeriesOfArticles)?.props
    ?.children;

  const description = children?.find(
    (x) => x.type === Description_SeriesOfArticles
  )?.props?.children;

  return (
    <nav aria-label={'Series of Articles'}>
      <Heading level={2} styleLevel={3} cssStyle={{ marginTop: '1.5em' }}>
        In this Series
      </Heading>
      {description}
      {title && <Heading level={3}>{title}</Heading>}
      {children}
    </nav>
  );
}
SeriesOfArticles.propTypes = {
  children: PropTypes.node,
};

export default SeriesOfArticles;
